(function webpackUniversalModuleDefinition(root, factory) {
	//CommonJS2 export
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"));
	//AMD export
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types"], factory);
	//CommonJS export
	else if(typeof exports === 'object')
		exports["SSuggestor"] = factory(require("react"), require("prop-types"));
	//Root export
	else
		root["SSuggestor"] = factory(root["React"], root["PropTypes"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_prop_types__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./config/helpers.js":
/*!***************************!*\
  !*** ./config/helpers.js ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

(function (global) {
  var babelHelpers = global.babelHelpers = {};

  babelHelpers.classCallCheck = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  babelHelpers.createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  babelHelpers.extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  babelHelpers.inherits = function (subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : babelHelpers.typeof(superClass)));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  };

  babelHelpers.interopRequireDefault = function (obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  };

  babelHelpers.possibleConstructorReturn = function (self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && ((typeof call === "undefined" ? "undefined" : babelHelpers.typeof(call)) === "object" || typeof call === "function") ? call : self;
  };
})(typeof global === "undefined" ? self : global);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../node_modules/webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./src/styles/index.scss":
/*!*******************************!*\
  !*** ./src/styles/index.scss ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/suggestor/ListItem.jsx":
/*!************************************!*\
  !*** ./src/suggestor/ListItem.jsx ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(/*! react */ "react");

var _react2 = babelHelpers.interopRequireDefault(_react);

var _propTypes = __webpack_require__(/*! prop-types */ "prop-types");

var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

var _autoBind = __webpack_require__(/*! ../utils/auto-bind */ "./src/utils/auto-bind.js");

var _autoBind2 = babelHelpers.interopRequireDefault(_autoBind);

var _MarkItem = __webpack_require__(/*! ./MarkItem */ "./src/suggestor/MarkItem.jsx");

var _MarkItem2 = babelHelpers.interopRequireDefault(_MarkItem);

var ListItem = function (_PureComponent) {
	babelHelpers.inherits(ListItem, _PureComponent);

	function ListItem(props) {
		babelHelpers.classCallCheck(this, ListItem);

		var _this = babelHelpers.possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this, props));

		(0, _autoBind2.default)(_this);
		return _this;
	}

	babelHelpers.createClass(ListItem, [{
		key: 'handleClick',
		value: function handleClick(event) {
			event.stopPropagation();
			var _props = this.props,
			    item = _props.item,
			    onItemClick = _props.onItemClick;

			onItemClick(item);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			event.stopPropagation();
			var _props2 = this.props,
			    index = _props2.index,
			    onItemMouseEnter = _props2.onItemMouseEnter;

			onItemMouseEnter(index);
		}
	}, {
		key: 'render',
		value: function render() {
			var _props3 = this.props,
			    item = _props3.item,
			    overItem = _props3.overItem,
			    search = _props3.search,
			    _props3$theme = _props3.theme,
			    li = _props3$theme.item,
			    liActive = _props3$theme.activeItem;

			var classes = [li, overItem && liActive].filter(function (classname) {
				return !!classname;
			}).join(' ');

			return _react2.default.createElement(
				'li',
				{ className: classes, onClick: this.handleClick, onMouseEnter: this.handleMouseEnter },
				_react2.default.createElement(_MarkItem2.default, { item: item, search: search })
			);
		}
	}]);
	return ListItem;
}(_react.PureComponent);

ListItem.propTypes = {
	item: _propTypes2.default.object.isRequired,
	index: _propTypes2.default.number.isRequired,
	overItem: _propTypes2.default.bool.isRequired,
	onItemClick: _propTypes2.default.func.isRequired,
	onItemMouseEnter: _propTypes2.default.func.isRequired,
	search: _propTypes2.default.string.isRequired,
	theme: _propTypes2.default.shape({
		item: _propTypes2.default.string,
		activeItem: _propTypes2.default.string
	})
};

exports.default = ListItem;

/***/ }),

/***/ "./src/suggestor/MarkItem.jsx":
/*!************************************!*\
  !*** ./src/suggestor/MarkItem.jsx ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(/*! react */ "react");

var _react2 = babelHelpers.interopRequireDefault(_react);

var _propTypes = __webpack_require__(/*! prop-types */ "prop-types");

var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

var MarkItem = function MarkItem(_ref) {
	var item = _ref.item,
	    search = _ref.search;
	var index = item.index,
	    word = item.word;


	if (!search || index === -1) {
		return _react2.default.createElement(
			'a',
			null,
			word
		);
	}

	var length = search.length;


	return _react2.default.createElement(
		'a',
		null,
		_react2.default.createElement(
			'span',
			null,
			word.substr(0, index),
			_react2.default.createElement(
				'strong',
				null,
				word.substr(index, length)
			),
			word.substr(index + length)
		)
	);
};

MarkItem.propTypes = {
	item: _propTypes2.default.shape({
		index: _propTypes2.default.number.isRequired,
		word: _propTypes2.default.string.isRequired
	}).isRequired,
	search: _propTypes2.default.string.isRequired
};

exports.default = MarkItem;

/***/ }),

/***/ "./src/suggestor/Suggestor.jsx":
/*!*************************************!*\
  !*** ./src/suggestor/Suggestor.jsx ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(/*! react */ "react");

var _react2 = babelHelpers.interopRequireDefault(_react);

var _propTypes = __webpack_require__(/*! prop-types */ "prop-types");

var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

var _utils = __webpack_require__(/*! ../utils */ "./src/utils/index.js");

var _transform = __webpack_require__(/*! ../utils/transform */ "./src/utils/transform.js");

var _transform2 = babelHelpers.interopRequireDefault(_transform);

var _ListItem = __webpack_require__(/*! ./ListItem */ "./src/suggestor/ListItem.jsx");

var _ListItem2 = babelHelpers.interopRequireDefault(_ListItem);

var Suggestor = function (_PureComponent) {
	babelHelpers.inherits(Suggestor, _PureComponent);

	function Suggestor(props) {
		babelHelpers.classCallCheck(this, Suggestor);

		var _this = babelHelpers.possibleConstructorReturn(this, (Suggestor.__proto__ || Object.getPrototypeOf(Suggestor)).call(this, props));

		(0, _utils.autoBind)(_this);

		_this.input = _react2.default.createRef();

		_this.state = {
			filtered: _this.filter(props.list, props.value, false),
			value: props.value,
			open: false,
			index: 0
		};
		return _this;
	}

	babelHelpers.createClass(Suggestor, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			document.addEventListener('click', this._onClick);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			document.removeEventListener('click', this._onClick);
		}
	}, {
		key: '_onClick',
		value: function _onClick(event) {
			if (!this.input.current.parentNode.contains(event.target)) {
				this.close();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var value = this.state.value;

			if (nextProps.value !== this.props.value && nextProps.value !== value) {
				value = nextProps.value;
			}

			this.setState({
				filtered: this.filter(nextProps.list, value, true),
				value: value
			});
		}
	}, {
		key: 'close',
		value: function close() {
			this.setState({
				open: false,
				filtered: this.unfilter(),
				index: 0
			});
		}
	}, {
		key: 'handleClick',
		value: function handleClick() {
			if (this.props.openOnClick) {
				if (this.state.open) {
					this.close();
				} else {
					this.setState({ open: true, filtered: this.unfilter() });
				}
			}
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(e) {
			var _props = this.props,
			    onKey = _props.onKey,
			    useKeys = _props.useKeys;

			onKey(e);

			if (useKeys && this.processKey(e.keyCode)) {
				e.preventDefault();
			}
		}
	}, {
		key: 'processKey',
		value: function processKey(code) {
			var _state = this.state,
			    open = _state.open,
			    index = _state.index,
			    filtered = _state.filtered,
			    value = _state.value;

			var ssuggestions = filtered.length ? filtered : this.unfilter();
			var nextIndex = void 0;

			switch (code) {
				case _utils.keys.ENTER:
					if (open && filtered[index]) {
						this.changeValue(filtered[index].word, true);
					} else {
						this.setState({ open: true, filtered: this.unfilter() });
					}
					break;
				case _utils.keys.ESCAPE:
					this.close();
					if (!open && value) {
						this.changeValue('');
					}
					break;
				case _utils.keys.DOWN:
					nextIndex = (index + open) % ssuggestions.length;
					break;
				case _utils.keys.UP:
					nextIndex = (index || ssuggestions.length) - 1;
					break;
				case _utils.keys.TAB:
					if (this.props.selectOnTab && open && filtered[index]) {
						this.changeValue(filtered[index].word, true);
					} else {
						this.close();
					}
				default:
					return false;
			}

			if (nextIndex !== undefined) {
				this.setState({ open: true, index: nextIndex, filtered: ssuggestions });
			}

			return true;
		}
	}, {
		key: 'handleItemClick',
		value: function handleItemClick(_ref) {
			var word = _ref.word;

			this.changeValue(word, true);
		}
	}, {
		key: 'handleItemMouseEnter',
		value: function handleItemMouseEnter(index) {
			this.setState({ index: index });
		}
	}, {
		key: 'handleChange',
		value: function handleChange(e) {
			e.stopPropagation();
			var value = e.target.value;
			this.changeValue(value);
		}
	}, {
		key: 'remove',
		value: function remove() {
			this.changeValue('', true);
		}
	}, {
		key: 'changeValue',
		value: function changeValue(value) {
			var _this2 = this;

			var select = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
			var _props2 = this.props,
			    list = _props2.list,
			    suggestOn = _props2.suggestOn,
			    accents = _props2.accents,
			    onChange = _props2.onChange,
			    onSelect = _props2.onSelect;

			var filtered = this.filter(list, value);
			var suggest = value.length >= suggestOn;
			var open = !!filtered.length && suggest;

			this.setState({ value: value, filtered: filtered, open: open }, function () {
				onChange(value);
				if (select) {
					var suggestion = filtered.find(function (_ref2) {
						var word = _ref2.word;
						return (0, _transform2.default)(accents, word) === (0, _transform2.default)(accents, value);
					});
					onSelect(value, suggestion && suggestion.item);
					_this2.close();
				}
			});
		}
	}, {
		key: 'filter',
		value: function filter(list, value) {
			var onlyMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
			var _props3 = this.props,
			    accents = _props3.accents,
			    selector = _props3.selector;

			value = (0, _transform2.default)(accents, value);

			var mapped = list.map(function (item) {
				var word = selector(item);
				return {
					index: (0, _transform2.default)(accents, word).indexOf(value),
					word: word,
					item: item
				};
			});
			if (onlyMatch) {
				mapped = mapped.filter(function (item) {
					return item.index !== -1;
				});
			}
			return mapped;
		}
	}, {
		key: 'unfilter',
		value: function unfilter() {
			return this.filter(this.props.list, this.state.value, false);
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.current.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props4 = this.props,
			    theme = _props4.theme,
			    style = _props4.style,
			    placeholder = _props4.placeholder,
			    arrow = _props4.arrow,
			    close = _props4.close,
			    tooltip = _props4.tooltip,
			    required = _props4.required;
			var _state2 = this.state,
			    open = _state2.open,
			    value = _state2.value,
			    index = _state2.index,
			    filtered = _state2.filtered;

			var displaySuggestions = open && !!filtered.length;

			return _react2.default.createElement(
				'div',
				{ className: theme.root, onClick: this.handleClick, onKeyDown: this.handleKeyDown, style: style },
				_react2.default.createElement('input', {
					type: 'text',
					className: theme.input,
					onChange: this.handleChange,
					value: value,
					title: tooltip,
					placeholder: placeholder,
					required: required,
					ref: this.input
				}),
				arrow && _react2.default.createElement('span', { className: theme.arrow }),
				close && value && _react2.default.createElement('span', { className: theme.close, onClick: this.remove }),
				displaySuggestions && _react2.default.createElement(
					'ul',
					{ className: theme.list },
					filtered.map(function (item, i) {
						return _react2.default.createElement(_ListItem2.default, {
							key: item.word,
							theme: theme,
							item: item,
							index: i,
							onItemClick: _this3.handleItemClick,
							onItemMouseEnter: _this3.handleItemMouseEnter,
							overItem: i === index,
							search: value
						});
					})
				)
			);
		}
	}]);
	return Suggestor;
}(_react.PureComponent);

Suggestor.propTypes = {
	list: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])).isRequired,
	selector: _propTypes2.default.func,
	onChange: _propTypes2.default.func,
	onSelect: _propTypes2.default.func,
	onKey: _propTypes2.default.func,
	value: _propTypes2.default.string,
	openOnClick: _propTypes2.default.bool,
	selectOnTab: _propTypes2.default.bool,
	placeholder: _propTypes2.default.string,
	tooltip: _propTypes2.default.string,
	theme: _propTypes2.default.shape({
		root: _propTypes2.default.string,
		arrow: _propTypes2.default.string,
		close: _propTypes2.default.string,
		list: _propTypes2.default.string,
		item: _propTypes2.default.string,
		activeItem: _propTypes2.default.string
	}),
	suggestOn: _propTypes2.default.number,
	style: _propTypes2.default.object,
	required: _propTypes2.default.bool,
	useKeys: _propTypes2.default.bool,
	accents: _propTypes2.default.bool,
	arrow: _propTypes2.default.bool,
	close: _propTypes2.default.bool
};

Suggestor.defaultProps = {
	theme: {},
	selector: function selector(s) {
		return s;
	},
	onSelect: _utils.noop,
	onChange: _utils.noop,
	onKey: _utils.noop,
	value: '',
	openOnClick: true,
	selectOnTab: false,
	suggestOn: 1,
	required: false,
	accents: false,
	useKeys: true,
	arrow: true,
	close: true
};

exports.default = Suggestor;

/***/ }),

/***/ "./src/utils/auto-bind.js":
/*!********************************!*\
  !*** ./src/utils/auto-bind.js ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
function autoBind(instance) {
	var constructor = 'constructor';

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = Object.getOwnPropertyNames(instance[constructor].prototype)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var propName = _step.value;

			var prop = instance[propName];
			if (propName !== constructor && prop instanceof Function) {
				instance[propName] = prop.bind(instance);
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}
}

exports.default = autoBind;

/***/ }),

/***/ "./src/utils/index.js":
/*!****************************!*\
  !*** ./src/utils/index.js ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = exports.keys = exports.autoBind = undefined;

var _autoBind = __webpack_require__(/*! ./auto-bind */ "./src/utils/auto-bind.js");

var _autoBind2 = babelHelpers.interopRequireDefault(_autoBind);

var _noop = __webpack_require__(/*! ./noop */ "./src/utils/noop.js");

var _noop2 = babelHelpers.interopRequireDefault(_noop);

var _keys = __webpack_require__(/*! ./keys */ "./src/utils/keys.js");

var _keys2 = babelHelpers.interopRequireDefault(_keys);

exports.autoBind = _autoBind2.default;
exports.keys = _keys2.default;
exports.noop = _noop2.default;

/***/ }),

/***/ "./src/utils/keys.js":
/*!***************************!*\
  !*** ./src/utils/keys.js ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var keyCode = {
	TAB: 9,
	ENTER: 13,
	ESCAPE: 27,
	DOWN: 40,
	UP: 38
};

exports.default = keyCode;

/***/ }),

/***/ "./src/utils/noop.js":
/*!***************************!*\
  !*** ./src/utils/noop.js ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {};

/***/ }),

/***/ "./src/utils/strip-tilde.js":
/*!**********************************!*\
  !*** ./src/utils/strip-tilde.js ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
// https://unicode-table.com/es/#basic-latin

var LETTERS_MAP = {
	a: 'áäàãăắặằẳẵǎâấậầẫẩǟȧǡạȁảȃāąᶏẚåǻḁⱥ',
	e: 'éëèĕěȩḝêếệềểễḙėẹȅẻȇēḗḕⱸęᶒɇẽḛ',
	i: 'íĭǐîïḯịȉìỉȋīįᶖɨĩḭ',
	o: 'óŏǒôốộồổỗöȫȯȱọőȍòỏơớợờởỡȏꝋꝍⱺōṓṑǫǭøǿõṍṏȭ',
	u: 'úŭǔûṷüǘǚǜǖṳụűȕùủưứựừửữȗūṻųᶙůũṹṵ',
	n: 'ñńņ'
};

var map = {};

for (var letter in LETTERS_MAP) {
	var chars = LETTERS_MAP[letter];
	for (var i = 0; i < chars.length; i++) {
		map[chars[i]] = letter;
	}
}

var strip = function strip(str) {
	return str.replace(/[^\u0000-\u007F]/g, function (char) {
		return map[char] || char;
	});
};

exports.default = strip;

/***/ }),

/***/ "./src/utils/transform.js":
/*!********************************!*\
  !*** ./src/utils/transform.js ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stripTilde = __webpack_require__(/*! ./strip-tilde */ "./src/utils/strip-tilde.js");

var _stripTilde2 = babelHelpers.interopRequireDefault(_stripTilde);

function transform(keepAccents, value) {
	var lowered = value.toLowerCase();
	return keepAccents ? lowered : (0, _stripTilde2.default)(lowered);
}

exports.default = transform;

/***/ }),

/***/ 0:
/*!***************************************************************************************!*\
  !*** multi ./src/styles/index.scss ./config/helpers.js ./src/suggestor/Suggestor.jsx ***!
  \***************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! /Users/carloluis/code/me/ssuggestor/src/styles/index.scss */"./src/styles/index.scss");
__webpack_require__(/*! /Users/carloluis/code/me/ssuggestor/config/helpers.js */"./config/helpers.js");
module.exports = __webpack_require__(/*! /Users/carloluis/code/me/ssuggestor/src/suggestor/Suggestor.jsx */"./src/suggestor/Suggestor.jsx");


/***/ }),

/***/ "prop-types":
/*!*********************************************************************************************************!*\
  !*** external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"} ***!
  \*********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_prop_types__;

/***/ }),

/***/ "react":
/*!**************************************************************************************!*\
  !*** external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"} ***!
  \**************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ });
});